export default "__VITE_PUBLIC_ASSET__0682dbeb__"